import React, { useState, useContext, useEffect } from "react";
import { Button, Box, TableBody, TableHead, TablePagination, makeStyles, InputAdornment, SvgIcon, Checkbox, Grid } from "@material-ui/core";
import { Search as SearchIcon } from "react-feather";
import { useForm } from "react-hook-form";
import { categoriesServices, productsServices } from "../services";
import { AuthContext } from "../context";
import { Toast } from "./";
import moment from "moment";
import { ModalBase, TextField, StyledTableCell, StyledTableRow, BaseTable } from "./";

export default function AssignProductDoctorCategory(props) {
	const classes = useStyles();
	const { authState } = useContext(AuthContext);
	const [limit, setLimit] = useState(100);
	const [page, setPage] = useState(1);
	const [count, setCount] = useState(0);
	const [laboratoryId] = useState(authState.user.laboratory._id);
	const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
	const [categories, setCategories] = useState([]);
	const [toast, setToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const { register, handleSubmit, errors } = useForm();
	const [reload, setReload] = useState(false);

	useEffect(() => {
		setReload(false);
		async function getCategoriesLaboratory() {
			try {
				const { status, response } = await categoriesServices.getCategoriesLaboratory({
					laboratoryId,
					token: authState.token,
					page,
					limit,
				});
				if (status === 200) {
					if (response.categories.length > 0) {
						setCategories(response.categories);
						setLimit(response.limit);
						setCount(response.total);
						setPage(response.page);
					} else {
						setCategories([]);
						setLimit(response.limit);
						setCount(response.total);
						setPage(response.page);
					}
				}
			} catch (e) {
				console.log(e);
			}
		}
		getCategoriesLaboratory();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, limit, reload, authState]);

	const handleSelectOne = (event, id) => {
		const selectedIndex = selectedCategoryIds.indexOf(id);
		let newSelectedCategoryIds = [];

		if (selectedIndex === -1) {
			newSelectedCategoryIds = newSelectedCategoryIds.concat(selectedCategoryIds, id);
		} else if (selectedIndex === 0) {
			newSelectedCategoryIds = newSelectedCategoryIds.concat(selectedCategoryIds.slice(1));
		} else if (selectedIndex === selectedCategoryIds.length - 1) {
			newSelectedCategoryIds = newSelectedCategoryIds.concat(selectedCategoryIds.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelectedCategoryIds = newSelectedCategoryIds.concat(
				selectedCategoryIds.slice(0, selectedIndex),
				selectedCategoryIds.slice(selectedIndex + 1)
			);
		}

		setSelectedCategoryIds(newSelectedCategoryIds);
	};

	const assignProduct = async (product) => {
		if (selectedCategoryIds.length === 0) {
			setToast(true);
			setToastMessage("Seleccione al menos una categoría para asignar producto");
		} else {
			let categoriesIds = [];
			selectedCategoryIds.forEach((id) => {
				categoriesIds.push({
					_id: id,
				});
			});

			let payload = {
				laboratoryId: laboratoryId,
				productId: props.productId,
				assigned: product.quantity,
				categories: categoriesIds,
			};
			try {
				const { status, response } = await productsServices.assignProductCategory({ payload, token: authState.token });
				switch (status) {
					case 200:
						props.toast(response.message, true);
						props.close();
						props.reload();
						break;
					default:
						break;
				}

				if (response.error) {
					props.toast(response.error.message, true);
				}
			} catch (e) {
				console.log(e);
			}
		}
	};

	const getFilterCategoriesLaboratory = async (text) => {
		try {
			const { status, response } = await categoriesServices.getFilterCategoriesLaboratory({ text, laboratoryId, token: authState.token });
			if (status === 200) {
				if (response.categories.length > 0) {
					setCategories(response.categories);
					setLimit(response.limit);
					setCount(response.total);
					setPage(response.page);
				} else {
					setCategories([]);
					setLimit(response.limit);
					setCount(response.total);
					setPage(response.page);
				}
			}
		} catch (e) {
			console.log(e);
		}
	};

	return (
		<ModalBase categoryModal open={props.open} close={props.close} title="Seleccionar categoría">
			<Toast
				message={toastMessage}
				open={toast}
				close={() => {
					setToast(false);
				}}
			/>
			<form className={classes.form} onSubmit={handleSubmit(assignProduct)}>
				<Box mt={3}>
					<Grid container direction="row" spacing={2} alignItems="center" justify="center">
						<Grid item xs={12} sm={4}>
							<TextField
								onChange={(e) => {
									getFilterCategoriesLaboratory(e.target.value);
								}}
								fullWidth
								name="text"
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SvgIcon fontSize="small" color="action">
												<SearchIcon />
											</SvgIcon>
										</InputAdornment>
									),
								}}
								placeholder="Buscar"
								variant="outlined"
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<TextField
								defaultValue={1}
								required
								InputProps={{ inputProps: { min: 1 } }}
								type="number"
								label="Cantidad de producto"
								variant="outlined"
								name="quantity"
								id="quantity"
								error={errors.quantity ? true : false}
								inputRef={register({ required: "Cantidad requerida" })}
								helperText={errors.quantity ? errors.quantity.message : ""}
							/>
						</Grid>
						<Grid item sm={2} xs={12}>
							<Button
								fullWidth
								size="small"
								variant="contained"
								color="secondary"
								className={classes.button}
								type="submit"
								style={{ textTransform: "capitalize", borderRadius: "20px" }}
							>
								Asignar
							</Button>
						</Grid>
						<Grid item sm={2} xs={12}>
							<Button
								fullWidth
								size="small"
								variant="contained"
								color="primary"
								onClick={props.close}
								className={`${classes.button} ${classes.cancel}`}
								style={{ textTransform: "capitalize", borderRadius: "20px" }}
							>
								Cancelar
							</Button>
						</Grid>
					</Grid>
					<BaseTable>
						<TableHead>
							<StyledTableRow>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell>Nombre</StyledTableCell>
								<StyledTableCell>Descripción</StyledTableCell>
								<StyledTableCell>Creación</StyledTableCell>
							</StyledTableRow>
						</TableHead>
						<TableBody>
							{categories.map((category) => (
								<StyledTableRow key={category._id}>
									<StyledTableCell>
										<Checkbox
											checked={selectedCategoryIds.indexOf(category._id) !== -1}
											onChange={(event) => handleSelectOne(event, category._id)}
											value="true"
										/>
									</StyledTableCell>
									<StyledTableCell>{category.name}</StyledTableCell>
									<StyledTableCell>{category.description}</StyledTableCell>
									<StyledTableCell>{moment(category.createdAt).format("DD/MM/YYYY")}</StyledTableCell>
								</StyledTableRow>
							))}
						</TableBody>
					</BaseTable>
					<TablePagination
						labelRowsPerPage="Registros por página"
						component="div"
						count={count}
						onChangeRowsPerPage={(e) => setLimit(e.target.value)}
						onChangePage={(e, page) => setPage(page + 1)}
						page={page - 1}
						rowsPerPage={limit}
						rowsPerPageOptions={[10, 25, 50, 100]}
					/>
				</Box>
			</form>
		</ModalBase>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	button: {
		height: 45,
		borderRadius: 25,
		boxShadow: "unset",
		textTransform: "uppercase",
		fontWeight: "bold",
		"&:hover": {
			boxShadow: "unset",
		},
	},
	cancel: {
		backgroundColor: "transparent",
		color: theme.palette.secondary.main,
		border: "3pt solid" + theme.palette.secondary.main,
		"&:hover": {
			backgroundColor: "transparent",
		},
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: "#f44336",
	},
	dialogTitle: {
		marginTop: "20px",
		textAlign: "Center",
	},
}));
